import clsx from "clsx";
import React from "react";
import { Typography } from "@mui/material";

export interface IContentTopProps {
	headerImage?: string;
	align?: string;
	icon?: string | React.ReactNode;
	title?: string | React.ReactNode;
	topRightComponent?: React.ReactNode;
}

const ContentTop: React.FC<Readonly<IContentTopProps>> = ({ align, headerImage, icon, title, topRightComponent }) => {
	return (
		<div className="flex bg-white min-h-[50px] m-auto px-5 w-[1440px] border-b-[0.75px] border-[#CCCCCC]">
			<div className={"flex flex-row flex-1"}>
				<div className={clsx("flex my-auto", { "m-auto": align === "center" })}>
					{headerImage ? (
						<div className="flex m-auto w-full">
							<img src={headerImage} className="dealer-logo-style transform-init" alt="logo banner" />
						</div>
					) : (
						<div className="flex justify-center">
							{icon && (
								<div className="flex my-auto mx-2 w-14">
									{typeof icon !== "string" ? icon : <img src={icon} alt="icon" className="m-auto h-[22px]" />}
								</div>
							)}
							<Typography component={"h1"} variant={"h1"} color={"text.primary"}>
								{title}
							</Typography>
						</div>
					)}
				</div>
			</div>
			{topRightComponent ? <div className="m-auto">{topRightComponent}</div> : null}
		</div>
	);
};

export default ContentTop;
